//import css
import './css/main.css'
// import img from './images/2_corousel.png'

const Main = (props)=>{
    return (
        <>
            <main className="main-container">
                <div className='discount'>
                    <h3 className='offer'> </h3>
                </div>
                <div className='img-box'>
                    
                </div>

                {/* <img src={img} alt="pic err " /> */}
            </main>
        </>
    )
}
export default Main;